import { buildAriBusinessUrl as buildUrl } from '@nexus/ari-lib';

import { getAriBusinessUrl } from '../config/global';

// The paths and the builder are shared with apps/ari (@nexus/ari-lib).
// Re-exported so callers here keep importing from one place.
export { ARI_BUSINESS_APP_PATH, ARI_BUSINESS_BILLING_PATH } from '@nexus/ari-lib';

/** Binds the shared builder to this app's configured portal URL. */
export function buildAriBusinessUrl(workspaceId?: string | null, path?: string): string {
  return buildUrl(getAriBusinessUrl(), workspaceId, path);
}
